import { css } from 'lit';
import isEqual from 'lodash-es/isEqual';
/* eslint-disable no-underscore-dangle */
/**
 * this is mostly a convenience function to be passed into hasChanged
 *
 * @param {*} a the first value
 * @param {*} b the second value
 * @returns {boolean} true if they're not equal, false if they are equal
 */
export default function _isNotEqual(a: unknown, b: unknown): boolean {
	return isEqual(a, b) === false;
}
/* eslint-enable no-underscore-dangle */
